export const variables = {
  headerHeight: 75,
  appDrawer: {
    expandedWidth: 260,
    mobileExpandedWidth: 260,
    sectionLinksWidth: 82,
  },
  pageContentPadding: 15,
  windowHeight: window.innerHeight - 61 - 
  window.innerHeight * 0.5,
};

export const zIndex = {
  appDrawer: 9999,
};

export const deviceBreakpoints = {
  lLaptop: 1440,
  mLaptop: 1280,
  tablet: 1024,
  sLaptop: 768,
  phone: 450,
  sPhone: 384,
};
